import { useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const TrialParticipantId = ({
  trialDetails,
  setTrialDetails,
  trialSetting,
  setSiteIdManual,
  setInfoSettingChanged,
  handleBasicInfoUpdate,
  ParticipantIdChanged,
  setParticipantIdChanged,
}) => {
  const trial_settings = trialDetails?.participant_id_setting;
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;

  const handleSettingTypeChange = (event) => {
    const { name, value } = event.target;
    setTrialDetails((prevDetails) => ({
      ...prevDetails,
      participant_id_setting: {
        ...prevDetails.participant_id_setting,
        [name]: value,
        id_change: true,
      },
    }));
    setInfoSettingChanged(true);
    setParticipantIdChanged(true);
  };

  const handleparticipantType = (isAutomatic) => {
    setTrialDetails({
      ...trialDetails,
      automatic_participant_type: isAutomatic,
      participant_id_setting: {
        ...trialDetails.participant_id_setting,
        setting_type: isAutomatic ? "Sequence" : "Manual",
        id_change: true,
      },
    });
    setParticipantIdChanged(true);
  };

  if (trialSetting === "Site Id" && trial_settings?.setting_type === "Manual") {
    setSiteIdManual(true);
  } else {
    setSiteIdManual(false);
  }

  useEffect(() => {
    if (trialDetails?.automatic_participant_type === false) {
      setTrialDetails((prevTrialDetails) => ({
        ...prevTrialDetails,
        participant_id_setting: {
          ...prevTrialDetails.participant_id_setting,
          setting_type: "Manual",
        },
      }));
    }
  }, [trialDetails?.automatic_participant_type]);

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <RadioGroup
          row
          value={trialDetails?.automatic_participant_type ? "automatic" : "manual"}
          onChange={(e) => handleparticipantType(e.target.value === "automatic")}
        >
          <FormControlLabel value="automatic" control={<Radio />} label="Automatic" />
          <FormControlLabel value="manual" control={<Radio />} label="Manual" />
        </RadioGroup>

        {role !== "Investigator" && role !== "Inv_coordinator" && role !== "Reviewer" && (
          <Button
            variant="contained"
            size="small"
            id="participant-settings"
            onClick={() => handleBasicInfoUpdate()}
            disabled={!ParticipantIdChanged}
          >
            Save
          </Button>
        )}
      </Box>

      {trialDetails?.automatic_participant_type && (
        <RadioGroup
          row
          name="setting_type"
          value={trial_settings?.setting_type || ""}
          onChange={handleSettingTypeChange}
          sx={{ mt: 2 }}
        >
          <FormControlLabel value="Sequence" control={<Radio />} label="Sequential" />
          <FormControlLabel value="Randomize" control={<Radio />} label="Randomize" />
        </RadioGroup>
      )}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2,
          mt: 2,
        }}
      >
        <TextField
          fullWidth
          label="Lower Value"
          size="small"
          type="number"
          inputProps={{ min: 1 }}
          name="lower_range"
          value={trial_settings?.lower_range || ""}
          onChange={handleSettingTypeChange}
          placeholder="Lower Value"
        />
        <TextField
          fullWidth
          label="Upper Value"
          size="small"
          type="number"
          inputProps={{ min: 1 }}
          name="upper_range"
          value={trial_settings?.upper_range || ""}
          onChange={handleSettingTypeChange}
          placeholder="Upper Value"
          required
        />
      </Box>
    </Box>
  );
};

export default TrialParticipantId;
